import { SessionIdSchema } from '@mntn-dev/domain-types'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { AuthSessionDataSchema } from './auth-session-data.ts'
import { AuthSessionPrincipalSchema } from './auth-session-principal.ts'

export const AuthSessionWithPrincipalSchema = AuthSessionDataSchema.extend({
  principal: AuthSessionPrincipalSchema,
  sessionId: SessionIdSchema,
  requestPathname: z.string().optional(),
})

export type AuthSessionWithPrincipal = ZodSimplify<
  typeof AuthSessionWithPrincipalSchema
>

export const isAuthSessionWithPrincipal = (
  value: unknown
): value is AuthSessionWithPrincipal => {
  return AuthSessionWithPrincipalSchema.safeParse(value).success
}

export const assertAuthSessionWithPrincipal = (
  value: unknown,
  message: string
): asserts value is AuthSessionWithPrincipal => {
  try {
    AuthSessionWithPrincipalSchema.parse(value)
  } catch (error) {
    throw new Error(
      `${message}: ${error instanceof Error ? error.message : String(error)}`
    )
  }
}
